import {Chip} from '@mui/material';

import {getScoreLevelColors, scorePillChipSx} from '../../../../../utils/getScoreLevelColors';

export interface Props {
  score: number;
}

/** Prototype `.score-pill` at 11px inside compare cards */
export const ProfileComparisonScorePill = ({score}: Props) => {
  const {bgcolor, color} = getScoreLevelColors(score);

  return (
    <Chip
      label={`${score}%`}
      size='small'
      sx={{
        height: 20,
        fontWeight: 600,
        fontSize: '11px',
        bgcolor,
        color,
        ...scorePillChipSx,
        '& .MuiChip-label': {px: 1.25, py: 0},
      }}
    />
  );
};
